import { FC } from "react";
import './Noindex.css';

const NoIndex: FC = () => {     
    return (
        <>
            <header className="header">
                <div className="nav-container">
                    <img className="logo-img" src="https://helpdeskmakos.com/img/yellow/favicon192.png"></img>
                    <a href="#" className="logo">Makos Clock</a>                                        
                </div>
            </header>

            <section className="hero" id="inicio">
                <div className="hero-content">
                    <h1>Control Inteligente de Empleados</h1>
                    <p>Gestión eficiente de entradas y salidas del personal en tiempo real, con reportes automáticos, identificación segura y estadísticas al instante desde cualquier dispositivo.</p>
                    <p>Disponible como función en tu membresía Makos.</p>
                    <a href="https://appmakos.com" target="_blank" className="cta-button">Makos</a>
                </div>
            </section>                    
        </>
    )
}  
export default NoIndex;